<template>
      <component v-bind:is="appName"></component>
</template>

<script>
import SearchApp from '@/components/apps/SearchApp'
import StatusApp from '@/components/apps/StatusApp'
import EterminMainApp from '@/components/apps/EterminMainApp'
import EterminCancellationApp from '@/components/apps/EterminCancellationApp'
import NearestStoresApp from '@/components/apps/NearestStoresApp'
import ServiceDrupal from '@/services/ServiceDrupal.js'

export default {
    name: 'app',
    components: {
        SearchApp,
        StatusApp,
        EterminMainApp,
        EterminCancellationApp,
        NearestStoresApp
    },
    data () {
        return {
            appName: '',
            id: '',
        }
    },
    mounted () {
        this.appName = this.$options.parent.appName
        this.id = this.$options.parent.id
    }
}
</script>
